import React, { useEffect } from "react";
import { Typography, Button, Box } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useNavigate } from "react-router-dom";
import { CartService } from "../services/functions/cartService";
import { useSignedInUserState } from "../hooks/useAuthState";
import { MetricsNames } from "../services/firebase/metricsService";
import { logEvent } from "../firebase";

const OrderTransactionFailedPage = () => {
    const navigate = useNavigate()

    const { profile } = useSignedInUserState();
    useEffect(() => {
        const load = async () => {
            CartService.cancelPendingOrder()
            logEvent(MetricsNames.PURCHASE_ERROR);
        }
        // Cleanup subscription on unmount
        load();
    }, [profile]);

    return (
        <Box
            sx={{
                backgroundColor: "#f5f5f5",
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                padding: 2,
            }}
        >
            <ErrorOutlineIcon sx={{ fontSize: 80, color: "error.main", marginBottom: 2 }} />
            <Typography variant="h4" gutterBottom color="error">
                Transaction Failed
            </Typography>
            <Typography variant="body1" align="center" sx={{ maxWidth: 400, marginBottom: 3 }}>
                Unfortunately, your transaction could not be completed. Please check your payment details and try again.
            </Typography>
            <Box>
                <Button
                    onClick={() => navigate("/order/confirm")}
                    variant="contained"
                    color="error"
                    sx={{ marginRight: 2 }}
                >
                    Retry Payment
                </Button>
                <Button
                    onClick={() => navigate("/search")}
                    variant="outlined"
                    color="primary"
                >
                    Back to Home
                </Button>
            </Box>
        </Box>
    );
};

export default OrderTransactionFailedPage;
